"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugLogger = void 0;
const eventEmitter_1 = require("./eventEmitter");
const GLOBAL_DEBUG_STORAGE_KEY = 'client-sdk-debug-mode';
class DebugLogger {
    constructor(componentName) {
        this.componentName = componentName;
    }
    log(message, ...args) {
        if (GlobalDebugger.getInstance().isEnabled()) {
            const timestamp = new Date().toISOString();
            console.log(`[Debugger::${this.componentName}] [${timestamp}] ${message}`, ...args);
        }
    }
    warn(message, ...args) {
        if (GlobalDebugger.getInstance().isEnabled()) {
            const timestamp = new Date().toISOString();
            console.warn(`[Debugger::${this.componentName}] [${timestamp}] ${message}`, ...args);
        }
    }
    on(event, handler) {
        const wrappedHandler = () => {
            const data = handler();
            return Array.isArray(data) ? data.map((item) => ({
                module: this.componentName,
                data: item,
            })) : [{
                    module: this.componentName,
                    data
                }];
        };
        GlobalDebugger.getInstance().on(event, wrappedHandler);
        return () => {
            GlobalDebugger.getInstance().off(event, wrappedHandler);
        };
    }
    off(event, handler) {
        GlobalDebugger.getInstance().off(event, handler);
    }
}
exports.DebugLogger = DebugLogger;
class GlobalDebugger extends eventEmitter_1.EventEmitter {
    constructor() {
        super();
        this._debugMode = this.loadStateFromStorage();
    }
    static getInstance() {
        if (typeof window !== 'undefined' && !window.globalDebugger) {
            window.globalDebugger = new GlobalDebugger();
        }
        return window.globalDebugger;
    }
    isEnabled() {
        return this._debugMode;
    }
    enable() {
        this._debugMode = true;
        this.saveStateToStorage(this._debugMode);
        console.log(`[SDK Debug] [${new Date().toISOString()}] Debug mode enabled globally`);
    }
    disable() {
        console.log(`[SDK Debug] [${new Date().toISOString()}] Debug mode disabled globally`);
        this._debugMode = false;
        this.saveStateToStorage(this._debugMode);
    }
    printStats() {
        console.log(`[SDK Debug] [${new Date().toISOString()}] Collecting stats from all modules...`);
        const allStats = this.emit('stats');
        if (allStats.length === 0) {
            console.log('[SDK Debug] No stats available');
            return;
        }
        allStats.forEach((moduleStats) => {
            if (Array.isArray(moduleStats)) {
                moduleStats.forEach((stat) => {
                    if (Array.isArray(stat.data)) {
                        console.log(`[${stat.module}]`, ...stat.data);
                    }
                    else {
                        console.log(`[${stat.module}]`, stat.data);
                    }
                });
            }
        });
    }
    loadStateFromStorage() {
        if (typeof window === 'undefined' || !window.sessionStorage) {
            return false;
        }
        try {
            const storedValue = window.sessionStorage.getItem(GLOBAL_DEBUG_STORAGE_KEY);
            return storedValue === 'true';
        }
        catch (error) {
            console.warn('[SDK Debug] Failed to load debug mode from sessionStorage:', error);
        }
        return false;
    }
    saveStateToStorage(state) {
        if (typeof window === 'undefined' || !window.sessionStorage) {
            return;
        }
        try {
            window.sessionStorage.setItem(GLOBAL_DEBUG_STORAGE_KEY, JSON.stringify(state));
        }
        catch (error) {
            console.warn('[SDK Debug] Failed to save debug mode to sessionStorage:', error);
        }
    }
}
